import React, { useEffect } from "react";

import { Skeleton } from "@mui/material";
import Box from "@mui/material/Box";
import Carousel from "react-material-ui-carousel";
import { useQuery } from "react-query";

import { fetchAnnounce } from "../../fetch/fetchAnnounce";
import { fetchUpdateUserSeenAnnouncement } from "../../fetch/fetchUser";
import { fetchEmployeeID } from "../../fetch/fecthActivity";

export default function Announcement() {
  const { data, status } = useQuery("announceToken", () => fetchAnnounce());

  useEffect(() => {
    const updateSeenAnnouncement = async () => {
      var empId = await fetchEmployeeID();
      if (empId !== undefined && empId.e > 0) {
        await fetchUpdateUserSeenAnnouncement(empId.e);
      }
    };
    updateSeenAnnouncement();
  }, []);

  return (
    <Box sx={{ maxWidth: 800, width: 1 }}>
      {status === "success" ? (
        <Carousel navButtonsAlwaysVisible="true">
          {data.data.map((step) => (
            <div key={step.announceId}>
              <Box
                component="img"
                sx={{
                  height: 510,
                  display: "block",
                  maxWidth: 800,
                  width: 1,
                  overflow: "hidden",
                  marginX: "auto",
                  objectFit: "contain",
                }}
                src={`${process.env.REACT_APP_WFH_TIME_ATTENDANCE_API_URL}/${step.img}`}
                alt={step.msg}
              />
            </div>
          ))}
        </Carousel>
      ) : (
        <Skeleton variant="rectangular" width={800} height={510} />
      )}
    </Box>
  );
}
